import { render, staticRenderFns } from "./PraticaExternalTracking.vue?vue&type=template&id=331eb522&scoped=true&"
import script from "./PraticaExternalTracking.vue?vue&type=script&lang=js&"
export * from "./PraticaExternalTracking.vue?vue&type=script&lang=js&"
import style0 from "./PraticaExternalTracking.vue?vue&type=style&index=0&id=331eb522&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331eb522",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('331eb522')) {
      api.createRecord('331eb522', component.options)
    } else {
      api.reload('331eb522', component.options)
    }
    module.hot.accept("./PraticaExternalTracking.vue?vue&type=template&id=331eb522&scoped=true&", function () {
      api.rerender('331eb522', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/pratica/PraticaExternalTracking.vue"
export default component.exports